import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddTruck';
import { useAuthValidation } from '../../utils/hooks';

const AddTruckPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddTruckPage;
